//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import formConfigList from '@/views/maintain/formConfig';
import * as systemGroupApi from '@/api/systemGroup';
import { Debounce } from '@/utils/validate';
export default {
  // name: "combinedDataEdit"
  components: {
    formConfigList: formConfigList
  },
  props: {
    isCreate: {
      type: Number,
      default: 0
    },
    editData: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      editPram: {
        formId: null,
        info: null,
        name: null,
        id: null
      },
      selectedFormConfigData: {},
      selectFormDialogConfig: {
        visible: false
      }
    };
  },
  mounted: function mounted() {
    this.handlerInitEditData();
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    },
    handlerInitEditData: function handlerInitEditData() {
      if (this.isCreate !== 1) return;
      var _this$editData = this.editData,
        id = _this$editData.id,
        name = _this$editData.name,
        info = _this$editData.info,
        formId = _this$editData.formId,
        createTime = _this$editData.createTime,
        updateTime = _this$editData.updateTime;
      this.editPram.id = id;
      this.editPram.name = name;
      this.editPram.info = info;
      this.editPram.formId = formId;
    },
    handlerSelectedRowData: function handlerSelectedRowData(rowData) {
      this.selectedFormConfigData = rowData;
      this.editPram.formId = this.selectedFormConfigData.id;
      this.selectFormDialogConfig.visible = false;
    },
    handlerSubmit: Debounce(function (form) {
      var _this = this;
      this.$refs[form].validate(function (result) {
        if (!result) return;
        _this.isCreate === 0 ? _this.handlerSave(_this.editPram) : _this.handlerEdit(_this.editPram);
      });
    }),
    handlerSave: function handlerSave(pram) {
      var _this2 = this;
      systemGroupApi.groupSave(pram).then(function (data) {
        _this2.$message.success('添加组合数据成功');
        _this2.$emit('hideDialog');
      });
    },
    handlerEdit: function handlerEdit(pram) {
      var _this3 = this;
      systemGroupApi.groupEdit(pram).then(function (data) {
        _this3.$message.success('编辑组合数据成功');
        _this3.$emit('hideDialog');
      });
    }
  }
};